<template>
  <div class="raceInformation">
    <img src="/static/img/expertTeam/banner.png" width="100%" />
    <!-- <childLogo></childLogo> -->
    <div class="navbar-dark">
      <div class="container">
        <div class="sigma-content">
          <div class="sigma-middle-line">
            <span class="sigma-line-text">赛事资讯</span>
          </div>
        </div>
        <div style="font-size: 21px;margin: 15px;color: #5e5e5e;">{{ siteName }}</div>
      </div>
    </div>

    <el-row>
      <el-col :span="4">
        <div class="competition-notice"></div>
      </el-col>
      <el-col :span="3">
        <div class="competition-notice" style="background-color: #fff">
          <el-tabs
            v-model="articleId"
            tab-position="left"
            class="competition-li"
            @tab-click="tabClick"
          >
            <!-- <el-tab-pane
              v-for="(item, index) in list"
              :key="index"
              :label="item.title"
              :name="item.id + ''"
            ></el-tab-pane>-->
            <el-tab-pane label="用户管理" name="76"></el-tab-pane>
            <el-tab-pane label="配置管理" name="77"></el-tab-pane>
            <el-tab-pane label="角色管理" name="78"></el-tab-pane>
          </el-tabs>
        </div>
      </el-col>
      <el-col :span="13">
        <div class="competition-notice">
          <el-row>
            <el-col :span="24">
              <div class="trends-notice">
                <div
                  :id="item.id"
                  :class="index === 0 ? 'trends-notice-content' : 'trends-notice-content-two'"
                  v-for="(item, index) in notices.slice(0,5)"
                  :key="index"
                  @click="toDetail(item.id)"
                >
                  <el-row>
                    <el-col :span="21">
                      <div class @click="toDetail(item.id)">{{ item.title }}</div>
                    </el-col>
                    <el-col :span="3">
                      <div class>{{ item.releaseDate }}</div>
                    </el-col>
                  </el-row>
                  <hr style="background-color: #666666; color: #666666" />
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
      <el-col :span="4">
        <div class="competition-notice"></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// import ChildLogo from "@/components/ChildLogo.vue";
import {siteMess} from "@/api/system/index"
export default {
  name: "Trends",
  // components: {
  //   ChildLogo: ChildLogo
  // },
  data() {
    return {
      siteName:"",
      channelId: 0,
      notices: [],
      articleId: "76"
    };
  },
  created() {
    siteMess(this.siteURL,this.siteId).then(res=>{
      this.siteName = res.data.name;
    })
    this.getNoticeContent();
  },
  methods: {
    getNoticeContent() {
      var api = this.siteURL + "/actuator/article/list?channelId=" + this.articleId;
      this.axios.get(api, {}).then(response => {
        this.notices = response.data.rows;
      });
    },
    toDetail(e) {
      let routeUrl = this.$router.resolve({
        path: "/detail",
        query: { id: e }
      });
      window.open(routeUrl.href, "_blank");
    },
    tabClick(tab) {
      this.articleId = tab.name;
      this.getNoticeContent();
    }
  }
};
</script>

<style scoped>
/* 通知公告基础模块 */
.trends {
  min-height: 80px;
}
/* 通知公告竖线样式 */
.trends-line {
  float: left;
  width: 5px;
  height: 50px;
  background-image: linear-gradient(#133c73, #37babd);
  margin-top: 20px;
}
.trends-text {
  margin-left: 10px;
  float: left;
  height: 40px;
  margin-top: 20px;
}
.trends-text-cn {
  font-size: 24px;
}
.trends-text-en {
  font-size: 15px;
  color: #666666;
}
/* 通知公告内容基础样式 */
.trends-notice {
  margin-top: 10px;
  padding-left: 20px;
  height: 300px;
  background-color: #f5f5f5;
  color: #666666;
  font-size: 18px;
  text-align: left;
}
/* 通知公告内容基础样式 */
.trends-notice-content {
  padding-top: 40px;
  color: #666666;
  cursor: pointer;
}
.trends-notice-content-two {
  padding-top: 30px;
  color: #666666;
  cursor: pointer;
}

.sigma-content {
  margin: 40px 0 10px;
  text-align: center;
  background-color: #fff;
}
.sigma-middle-line:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
  background-color: #0C70FC; /*颜色需与bai主题大背景du色一致zhi*/
  position: relative;
  top: 25px; /*调节线高*/
  left: 0;
}
.sigma-line-text {
  display: inline-block;
  background: #fff;
  padding: 0 18px 0 18px;
  position: relative;
  font-size: 28px;
  font-weight: 500;
  color: #0C70FC;
}

.competition-notice {
  margin-top: 10px;
  height: 560px;
  color: #666666;
  font-size: 20px;
  background-color: #f5f5f5;
}
/* 通知公告竖线样式 */
.competition-line {
  float: left;
  width: 5px;
  height: 50px;
  background-image: linear-gradient(#133c73, #37babd);
  margin-top: 20px;
}

.competition-content {
  white-space: pre-wrap;
  padding-top: 20px;
  padding-left: 20px;
  color: #707070;
  font-size: 18px;
  line-height: 36px;
  text-align: left;
}
</style>

<style>
/* el table pan样式修改 */
/* 去掉右边实线 */
.raceInformation .competition-li .el-tabs__header .el-tabs__nav-wrap::after {
  height: 0% !important;
}
/* 鼠标移入时的颜色改变 */
.raceInformation .el-tabs__item:hover {
  color: #0C70FC !important;
}
/* 选中效果文字与背景颜色修改 */
.raceInformation .el-tabs__item.is-active {
  color: #0C70FC !important;
  background-color: #e5e9f2;
}
/* 使元素充满整个div */
.raceInformation .el-tabs__header {
  width: 100% !important;
  height: 100% !important;
}
/* 选项元素样式修改 */
.raceInformation .el-tabs__item {
  color: #707070;
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  font-weight: 500;
}
/* 选中后 最右边竖线样式修改 */
.raceInformation .el-tabs__active-bar {
  /* background-image: linear-gradient(#133c73, #37babd); */
  background-color: #0C70FC;
}
.raceInformation .el-tabs--left .el-tabs__active-bar.is-left {
  width: 4px;
}
/* 文字居中 */
.raceInformation .el-tabs--left .el-tabs__item.is-left {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/RaceInformation.vue